export const MS_PER_DAY = 1000 * 60 * 60 * 24;
export const MS_PER_YEAR = MS_PER_DAY * 365;
export const MS_PER_WEEK = MS_PER_DAY * 7;
export const MS_PER_MONTH = MS_PER_YEAR / 12;
export const MS_PER_HOUR = 1000 * 60 * 60;
export const MS_PER_MINUTE = 1000 * 60;
export const MS_PER_SECOND = 1000;

export const fmtTimeDiff = (start: Date, end: Date) => {
  const difference = +end - +start; // difference in milliseconds
  const minutes = Math.floor(difference / MS_PER_MINUTE); // 1 minute = 60000 milliseconds
  const seconds = Math.floor((difference % MS_PER_MINUTE) / MS_PER_SECOND); // remainder in seconds
  const milliseconds = difference % MS_PER_SECOND; // remainder in milliseconds

  return `${minutes}m ${seconds}s ${milliseconds}ms`;
};

/**
 * @description Converts a number of days to a number of whole or partial weeks, rounding up.
 * @example
 * daysToWeeksCeil(7) // 1
 * daysToWeeksCeil(8) // 2
 */
export function daysToWeeksCeil(days: number): number {
  return Math.ceil(days / 7);
}
